import { HqDistanceResponse } from "../../../domain/models/hq-distance-report/hq-distance-data";
import { FetchHqDistance } from "../../../domain/useages/hq-distance-report/fetch-hq-distance";
import { HttpConstants } from "../../protocols/http/http-constants";
import { HttpGetClient } from "../../protocols/http/http-get-client";

export class RemoteFetchHqDistanceReport implements FetchHqDistance {
  constructor(
    private readonly url: string,
    private readonly httpGetClient: HttpGetClient
  ) {}

  async fetch(params: FetchHqDistance.Params): Promise<HqDistanceResponse> {
    const httpResponse = await this.httpGetClient.get({
      url: this.url,
      query: params,
      headers: {
        [HttpConstants.CONTENT_TYPE]: HttpConstants.APPLICATION_JSON,
        [HttpConstants.ACCEPT]: HttpConstants.APPLICATION_JSON,
         [HttpConstants.APP_ID]: HttpConstants.APP_ID_VALUE,
      },
      authHeaders: true,
    });
    if (httpResponse.status === 200) {
      return httpResponse.data;
    } else {
      throw new Error("Failed to fetch customer data");
    }
  }
}
